import { useState } from 'react'
import { Download } from 'lucide-react'
import { EXPORT_FORMATS } from '@mavatech/shared'
import { Button, Select } from '@/components/ui'
import { downloadBase64 } from '@/lib/download'
import { trpc } from '@/lib/trpc'
import { useAppStore } from '@/stores/app.store'

export function ExportTab({ year }: { year: number }) {
  const addToast = useAppStore((s) => s.addToast)
  const [month, setMonth] = useState('0')
  const [format, setFormat] = useState('generic_csv')

  const dl = trpc.export.download.useMutation({
    onSuccess: (r) => {
      if (r.notImplemented) {
        addToast({ type: 'info', title: 'Format geplant', description: r.message })
        return
      }
      for (const f of r.files) downloadBase64(f.filename, f.contentBase64, f.mime)
      addToast({ type: 'success', title: `${r.files.length} Datei(en) heruntergeladen` })
    },
    onError: (e) => addToast({ type: 'error', title: 'Fehler', description: e.message }),
  })

  return (
    <div className="p-6 space-y-5 max-w-lg">
      <p className="text-sm text-text-secondary">
        Buchungs-Export für den Steuerberater. Der generische CSV-Export enthält alle Felder für einen
        DATEV-/BMD-/RZL-Import; das konkrete Zielformat wird ergänzt, sobald es feststeht.
      </p>
      <div className="grid grid-cols-2 gap-4">
        <Select
          label="Zeitraum"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
          options={[
            { value: '0', label: `Ganzes Jahr ${year}` },
            ...Array.from({ length: 12 }, (_, i) => ({ value: String(i + 1), label: new Date(year, i, 1).toLocaleDateString('de-AT', { month: 'long' }) })),
          ]}
        />
        <Select label="Format" value={format} onChange={(e) => setFormat(e.target.value)} options={EXPORT_FORMATS.map((f) => ({ value: f.id, label: f.label }))} />
      </div>
      <Button
        variant="primary"
        loading={dl.isPending}
        onClick={() => dl.mutate({ year, month: month === '0' ? null : Number(month), format: format as never })}
      >
        <Download className="w-4 h-4" /> Export herunterladen
      </Button>
    </div>
  )
}
